import { useEffect, useState } from "react";
import useApi from "./useApi";

interface KlaviyoStatus {
  connected: boolean;
  accountName?: string;
}

export default function useKlaviyoStatus() {
  const [status, setStatus] = useState<KlaviyoStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      try {
        const resp = await api.admin.get("Klaviyo/Status");
        setStatus(await resp.json());
      } catch {
        setStatus({ connected: false });
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, [api.admin]);

  return { status, loading };
}
